import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function homeEditorial() {
  const editorialSection = document.querySelector(".home-editorial__container");
  const editorialHeader = document.querySelector(".home-editorial__header");
  const editorialColumn = document.querySelector(".home-editorial__column");

  if (editorialSection && editorialHeader && editorialColumn) {
    gsap.matchMedia().add("(min-width: 981px)", () => {
      ScrollTrigger.create({
        trigger: editorialSection,
        start: "top 124px",
        end: () =>
          "+=" +
          Math.max(
            0,
            editorialColumn.offsetHeight - editorialHeader.offsetHeight,
          ),
        pin: editorialHeader,
        pinSpacing: false,
        invalidateOnRefresh: true,
      });
    });
  }
}
